import { ChessBoard } from '../js/chess';
import { onDragStart } from './onDragStart';
import {
  ondrop,
  updateBoard,
  currentPuzzleMove,
  puzzlecurrentMove,
  dailypuzzlecurrentMove,
  currentdailyPuzzleMove,
  dailyDrop,
  clickDrop,
  puzzleMoveLength,
  onMoveEnd,
  highlightLastMove,
  WrongMove,
} from './onDrop'; // Import the updateBoard function
import { game } from './chess';
import axios from 'axios';
import { BehaviorSubject } from 'rxjs';
import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DecryptionService } from '../services/decryption.service';

declare let $: any;
let arrowCanvas: any;
let ctx: any;
let puzzlerated: any;
export let puzzlecurrentRating = new BehaviorSubject<any>(null);
export let chessBoard: any;
export let puzzleObj: any;
export let puzzleMoveapi: any;
export let dailypuzzleData: any;
export let response: any;
export let puzzleHighlightMove: any;
export let selectedPuzzleFinish: boolean;
const withoutloginPuzzle: any = [];
export let loaderShow: boolean;
export let chessboardForResize: any;

const injector = Injector.create({
  providers: [{ provide: HttpClient, deps: [] }, DecryptionService],
});

const decrtpService = injector.get(DecryptionService);
export const ChessboardFun = () => {
  const config = {
    position: 'start',
    draggable: true,
    snapbackSpeed: 500,
    snapSpeed: 100,
    onClick: clickDrop,
    onDragStart: onDragStart,
    onDrop: ondrop,
    onMoveEnd: onMoveEnd,
    onSnapEnd: () => {
      chessBoard.position(game.fen());
    },
  };
  chessBoard = ChessBoard('hijk', config);
  // newMove();
  $(window).resize(chessBoard.resize);
};

export const rotateChess = () => {
  chessBoard.flip();
  const moves: any = game.history({ verbose: true });
  const lastMove = moves.length ? moves[moves.length - 1] : null;
  highlightLastMove(lastMove?.from, lastMove?.to);
};

export const getLatestPosition = (data: string) => {
  game.loadPgn(data);
  chessBoard.position(game.fen());
};

export async function makeApiCall(data: any) {
  response = data;
  puzzleMoveLength(0);
  $('#nextPuzzle').hide();
  if (window.location.pathname === `/puzzle`) {
    if (response == null) {
      $('#puzzleHit').hide();
      $('#puzzleboardFilp').hide();
      $('#finishAllPuzzle').show();
      selectedPuzzleFinish = true;
    } else {
      loaderShow = false;

      const puzzlesMove = response.FEN;
      puzzleMoveapi = data.Moves.split(' ');
      puzzleHighlightMove = data.Moves;

      $('#puzzletheme').html(data.Themes);
      $('#puzzleLength').html(puzzleMoveapi.length / 2);

      game.load(puzzlesMove);
      chessBoard.position(game.fen());

      if (game.turn() === 'w') {
        chessBoard.orientation('black');
      } else {
        chessBoard.orientation('white');
      }
      updateBoard();

      setTimeout(() => {
        game.move(puzzleMoveapi[0]);
        chessBoard.position(game.fen());
        highlightLastMove(
          puzzleMoveapi[0].substring(0, 2),
          puzzleMoveapi[0].substring(2, 4)
        );

        puzzlecurrentMove();
        puzzleObj = puzzleMoveapi[1];
        updateBoard();
      }, 1500);
    }
  }
}

export async function gameIsnotRated(data: any) {
  puzzlerated = data.rated;
}

export async function puzzlecomplete() {
  var responseData: any;
  if (response !== null && response !== undefined) {
    withoutloginPuzzle.push(response.Index);
    const headertoken = JSON.parse(
      localStorage.getItem('loggedInUser') || '{}'
    );

    if (headertoken.token) {
      responseData = await axios.post(
        'https://api.chessx.ai/api/v1/puzzle/solvePuzzle',
        {
          puzzleIndex: response.Index,
          solve: WrongMove,
          rated: puzzlerated,
        },
        { headers: { 'x-auth-token': headertoken.token } }
      );
    }
    if (responseData) {
      const decrypt = decrtpService.decrypt(responseData.data.payload);
      const jsondecrpt = JSON.parse(decrypt);
      puzzlecurrentRating.next(jsondecrpt.rating);
    }
  }
}

export function makeMove(index: number, puzzleMoves: any) {
  if (index < puzzleMoves.length) {
    puzzleObj = puzzleMoves[index];
    if (currentPuzzleMove % 2 === 0) {
      game.move(puzzleObj);
      chessBoard.position(game.fen());
      highlightLastMove(puzzleObj.substring(0, 2), puzzleObj.substring(2, 4));
      updateBoard();
      puzzlecurrentMove();
      $('#hijk .box').remove();
      puzzleObj = puzzleMoves[index + 1];
    }
  }
}

export function hintData(data: any) {
  dailypuzzleData = data;
}

export function makedailyMove(index: number, puzzleMoves: any) {
  if (dailyDrop) {
    if (index < puzzleMoves.length) {
      dailypuzzleData = puzzleMoves[index];
      if (currentdailyPuzzleMove % 2 === 0) {
        game.move(dailypuzzleData);
        chessBoard.position(game.fen());
        highlightLastMove(
          dailypuzzleData.substring(0, 2),
          dailypuzzleData.substring(2, 4)
        );
        updateBoard();
        dailypuzzlecurrentMove();
        $('#hijk .box').remove();
        dailypuzzleData = puzzleMoves[index + 1];
      }
    }
  }
}

export function drawArrow(
  from: string,
  to: string,
  color: string = 'rgba(255,255,255,0.7)'
): void {
  clearCanvas();
  let fromX, fromY, toX, toY;
  const squareSize = arrowCanvas.width / 8;
  const margin = squareSize * 0.4; // Adjust this value to increase/decrease the distance from the pieces

  if (chessBoard.orientation() === 'white') {
    fromX = (from.charCodeAt(0) - 97) * squareSize + squareSize / 2;
    fromY = (8 - parseInt(from[1])) * squareSize + squareSize / 2;
    toX = (to.charCodeAt(0) - 97) * squareSize + squareSize / 2;
    toY = (8 - parseInt(to[1])) * squareSize + squareSize / 2;
  } else {
    fromX = (7 - (from.charCodeAt(0) - 97)) * squareSize + squareSize / 2;
    fromY = (parseInt(from[1]) - 1) * squareSize + squareSize / 2;
    toX = (7 - (to.charCodeAt(0) - 97)) * squareSize + squareSize / 2;
    toY = (parseInt(to[1]) - 1) * squareSize + squareSize / 2;
  }

  // Adjust the coordinates to add margin
  const angle = Math.atan2(toY - fromY, toX - fromX);
  fromX += margin * Math.cos(angle);
  fromY += margin * Math.sin(angle);
  toX -= margin * Math.cos(angle);
  toY -= margin * Math.sin(angle);

  const headlen = 10; // length of head in pixels

  ctx.strokeStyle = color;
  ctx.lineWidth = 8;
  ctx.beginPath();
  ctx.moveTo(fromX, fromY);
  ctx.lineTo(toX, toY);
  ctx.stroke();

  ctx.beginPath();
  ctx.moveTo(toX, toY);
  ctx.lineTo(
    toX - headlen * Math.cos(angle - Math.PI / 6),
    toY - headlen * Math.sin(angle - Math.PI / 6)
  );
  ctx.lineTo(
    toX - headlen * Math.cos(angle + Math.PI / 6),
    toY - headlen * Math.sin(angle + Math.PI / 6)
  );
  ctx.lineTo(toX, toY);
  ctx.lineTo(
    toX - headlen * Math.cos(angle - Math.PI / 6),
    toY - headlen * Math.sin(angle - Math.PI / 6)
  );
  ctx.stroke();
  ctx.fillStyle = color;
  ctx.fill();
}

export function initializeCanvas(elRef: any) {
  const boardContainer = elRef.nativeElement.querySelector('.Main-chessBoard');
  arrowCanvas = elRef.nativeElement.querySelector('#arrowCanvas');
  arrowCanvas.width = boardContainer?.clientWidth;
  arrowCanvas.height = boardContainer?.clientHeight;
  ctx = arrowCanvas.getContext('2d');
}

export function clearCanvas(): void {
  ctx.clearRect(0, 0, arrowCanvas.width, arrowCanvas.height);
}
